import { createSelector } from 'reselect';
import { ROUTE_COURSE_CERTIFICATION } from '../../routeActions';
import { selectLocation } from '../../location/selectors';

export const selectCurrentCertificationAction = createSelector(
  selectLocation,
  (location) => {
    if (location.get('type') === ROUTE_COURSE_CERTIFICATION) {
      return location.getIn(['params', 'action']).toLowerCase();
    } else {
      return null;
    }
  }
);
